import { LoyaltyType, TourPromotionViewModel } from '@api/index';
import { Promotions } from '@components/cards/opportunity/OpportunityCard';
import { FALLBACK_IMAGE_URL } from '@constants/constants';

import { SelectedVariations } from '../context/types';
import { PriceDetailsDrawerItem } from '../PriceDetails';

export const formatPriceDetails = (
  variations: SelectedVariations[]
): Array<PriceDetailsDrawerItem> =>
  variations.map((variation, index) => ({
    tabNumber: index,
    id: variation.id,
    title: variation.title || '',
    price: variation.price || 0,
    currency: variation.currency,
    guests: variation.guests,
    day: variation.day,
    nightCount: variation.nightCount,
    packageDetailId: variation.packageDetailId,
  })) || [];

export const formatTourPromotions = (
  tourPromotions?: TourPromotionViewModel[]
): Promotions[] =>
  tourPromotions
    ?.filter((item) => item.loyaltyType !== LoyaltyType.KOC_AILEM)
    .map((item) => ({
      name: item.name || '',
      description: item.description || '',
      image: item.image || FALLBACK_IMAGE_URL,
    })) || [];
